import { PressArticleCard } from "components/UI/molecules";
import "./index.scss";
import { presses } from "./constants";
import { EXTERNAL_LINKS } from "routes/paths";

export const Press = () => {
  return (
    <div className="press-container">
      <section className="section-intro">
        <h1>Press</h1>
        <p className="press-support">
          If you are a member of the media and are interested in covering GCX,
          please contact us at press@raise.com. Only media inquiries will
          receive a response. If you’re a GCX member or seller and have a
          question, please visit our Help Center.
        </p>
        <div className="press-list">
          {presses.map((press) => (
            <PressArticleCard
              key={press.name}
              press={press.name}
              img={press.img}
              title={press.title}
              url={press.url}
            />
          ))}
        </div>
        <hr className="divider" />
      </section>

      <section className="section-intro">
        <h2>About GCX</h2>
        <div className="about-gcx">
          <p>
            GCX is a leading retail payments company and the world’s largest
            gift card marketplace that connects members to buy discounted gift
            cards or sell their unwanted gift cards for cash. Partnered with
            more than 450 brands, GCX offers a new type of digital payment
            method for both retailers and consumers across the United States.
          </p>
          <p>
            With the GCX mobile wallet for iPhone and Android, members can take
            the marketplace on the go and redeem cards right at the store
            counter. Every transaction is backed by our 90 Day Money-Back
            Guarantee and since 2013 GCX has put over $150M back into the
            pockets of our members.
          </p>
          <p>
            To learn more or to try it yourself, visit GCX or download our
            mobile app from the App Store or Google Play.
          </p>
        </div>
        <hr className="divider" />
      </section>

      <section className="section-intro">
        <h2>Media Resources</h2>
        <div>
          <a
            href={EXTERNAL_LINKS.DOWNLOAD_MEDIA_KIT}
            download
            className="download-button"
          >
            Download Media Kit
          </a>
        </div>
      </section>

      <section className="section-intro">
        <p>
          For media inquiries, please contact{" "}
          <a href="mailto:press@raise.com">press@raise.com</a>.
        </p>
      </section>
    </div>
  );
};
